import BodyTableLine from '@/fsd/shared/ui/BodyTableLine';
import BodyTableLineItem from '@/fsd/shared/ui/BodyTableLineItem';
import { observer } from 'mobx-react-lite';
import { IReconciliation } from '@/fsd/entities/mutualSettlements';
import { mutualSettlementsStore } from '@/fsd/pages/mutual-settlements/model/store/MutualSettlementsStore';
import styles from '../../MutualSettlements/MutualSettlements.module.scss';
import StatusBlock from '@/fsd/shared/ui/status-block/status-block';
import { getCounterpartyTypeName } from '@/fsd/entities/counter-party/lib/helpers/getCounterpartyTypeName';
import { formatCurrency } from '@fsd/shared/lib/helpers/formatters/formatCurrency';

interface Props {
  reconciliation: IReconciliation;
}

const MutualSettlementsBodyLine = observer(({ reconciliation }: Props) => {
  return (
    <BodyTableLine
      onClick={() => mutualSettlementsStore.setSelectedId(reconciliation.id)}
    >
      {mutualSettlementsStore.checkIfColumnIsVisible('id') && (
        <>
          <BodyTableLineItem
            value={reconciliation.id}
            className={styles.columnId}
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('date') && (
        <>
          <BodyTableLineItem
            value={reconciliation.date_from}
            className={styles.columnDate}
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('organisation') && (
        <>
          <BodyTableLineItem
            value={reconciliation.organisation_name}
            className={styles.columnOrganisation}
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('counterparty') && (
        <>
          <BodyTableLineItem
            value={reconciliation.counterparty_name}
            className={styles.columnCounterparty}
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('start_period') && (
        <>
          <BodyTableLineItem
            value={formatCurrency(reconciliation.opening_balance)}
            className={styles.columnStartPeriod}
            additionalClass="alightAmount"
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('paid') && (
        <>
          <BodyTableLineItem
            value={formatCurrency(reconciliation.paid_total)}
            className={styles.columnPaid}
            additionalClass="alightAmount"
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('accepted') && (
        <>
          <BodyTableLineItem
            value={formatCurrency(reconciliation.accrued_total)}
            className={styles.columnAccepted}
            additionalClass="alightAmount"
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('end_period') && (
        <>
          <BodyTableLineItem
            value={formatCurrency(reconciliation.closing_balance)}
            className={styles.columnEndPeriod}
            additionalClass="alightAmount"
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
      {mutualSettlementsStore.checkIfColumnIsVisible('status') && (
        <>
          <BodyTableLineItem
            value={
              <StatusBlock
                label={
                  getCounterpartyTypeName(reconciliation.counterparty_type) ||
                  '-'
                }
                status={reconciliation.counterparty_type ? 'success' : 'error'}
              />
            }
            className={styles.columnStatus}
          />
          <BodyTableLineItem additionalClass="empty" />
        </>
      )}
    </BodyTableLine>
  );
});

export default MutualSettlementsBodyLine;
